import {IconType} from "../lib/interstate";
import {EmbeddedComponent, isEmbeddedComponent} from "./EmbeddedComponent";

export interface SidebarComponent extends EmbeddedComponent {
  path: string;
  icon: IconType;
}

export function isSidebarComponent(arg: any): arg is SidebarComponent {
  return (
    isEmbeddedComponent(arg) &&
    "path" in arg &&
    "icon" in arg &&
    typeof arg.path === "string" &&
    typeof arg.icon === "string"
  );
}

export const pageTitleKeyFor = (component: SidebarComponent) =>
  `sidebar-components.${component.id}.page-title`;

export const pageSummaryKeyFor = (component: SidebarComponent) =>
  `sidebar-components.${component.id}.page-summary`;

export const menuLabelKeyFor = (component: SidebarComponent) =>
  `sidebar-components.${component.id}.menu-label`;
